module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._l((_vm.messages), function(message) {
    return [(!_vm.activeMessage || _vm.activeMessage === message) ? _c('v-container', {
      key: message.message_id
    }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(message.message_title))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-5",
      staticStyle: {
        "overflow": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(message.message_body ? message.message_body.message_body : '')
      }
    }), _vm._v(" "), (!_vm.activeMessage) ? _c('v-card-text', {
      staticClass: "grey lighten-5"
    }, [(message.replies.length) ? _c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.activeMessage = message
        }
      }
    }, [_vm._v(_vm._s(message.replies.length) + " Antworten")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "blue",
        "fab": "",
        "dark": "",
        "small": "",
        "absolute": "",
        "bottom": "",
        "right": ""
      }
    }, [_c('v-icon', [_vm._v("menu")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()]
  }), _vm._v(" "), (_vm.activeMessage) ? _vm._l((_vm.activeMessage.replies), function(msg) {
    return _c('v-container', {
      key: msg.message_id
    }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(msg.message_title))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-5",
      staticStyle: {
        "overflow": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(msg.message_body ? msg.message_body.message_body : '')
      }
    })], 1)], 1)
  }) : _vm._e(), _vm._v(" "), _c('v-container', [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(_vm.activeMessage ? 'Antwort' : 'Nachricht') + " verfassen")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "placeholder": "Betreff"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-5"
  }, [_c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-5"
  }, [_c('v-btn', {
    attrs: {
      "color": "blue",
      "fab": "",
      "dark": "",
      "small": "",
      "absolute": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5248563c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/communication/Messages.vue
// module id = 586
// module chunks = 1